import * as notifier from './notifier.js';
import * as loader from './loader.js';
import * as claims from '../xhr/claims.js';
import * as types from './types/claims.js';
import * as spendingAccountsTypes from './types/spendingAccounts.js';
import { i18n, tokens } from '@simplybenefits/sb-ui-library';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @param form
 * @param type
 * @returns {function(*=): Promise<boolean>}
 */
export function submitClaim(form, type = 'standard') {
    return (dispatch) => {
        setLoader(dispatch, true, 'modal');

        return claims
            .submitClaim(form)
            .then((data) => {
                if (data.fixableClaimErrors) {
                    setLoader(dispatch, false);
                    return data;
                }

                if (type === 'HealthSpending') {
                    dispatch({
                        type: spendingAccountsTypes.ADD_HEALTH_USAGE,
                        data
                    });
                } else if (type === 'Lifestyle') {
                    dispatch({
                        type: spendingAccountsTypes.ADD_LIFESTYLE_CLAIM,
                        data
                    });
                } else {
                    dispatch({
                        type: types.ADD_CLAIM_SUCCESS,
                        claim: data
                    });
                }

                setLoader(dispatch, false);

                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);

                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param claimID
 * @returns {function(*=): Promise<boolean>}
 */
export function getClaimsSummary(claimID) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return claims.getClaimSummary(claimID)
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param filters
 * @param sort
 * @returns {function(*): Promise<*>}
 */
export function getClaims(filters = {}, sort = false) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return claims.getClaims(filters, sort)
            .then((claimsData) => {
                setLoader(dispatch, false);

                dispatch({
                    type: types.GET_CLAIMS,
                    claims: claimsData
                });
            })
            .catch((error) => {
                setLoader(dispatch, false);
                notifier.displayError(error.verbiage);
            });
    };
}

/**
 * @param claimID
 * @returns {function(*): Promise<*>}
 */
export function sendClaimApprovalEmail(claimID) {
    return () => claims.sendClaimApprovalEmail(claimID)
        .catch((error) => {
            notifier.displayError(error.verbiage);
        });
}

/**
 * @param dateRange
 * @param category
 * @param service
 * @returns {function(*): Promise<unknown>}
 */
export function createClaimsSummaryReport(dateRange, category, service) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return claims.createClaimsSummaryReport(dateRange, category, service)
            .then(() => {
                setLoader(dispatch, false);

                dispatch(notifier.displayMessage(i18n.t(tokens.labels.notifications.claimsSummaryReportSentSuccessfully)));
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error.verbiage));
            });
    };
}